/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:91a6d441-44a6-464b-b25b-ccb925d3626c",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_jUSRLsmwb",
    "aws_user_pools_web_client_id": "6l1qa6gtgs715fv16eo6kr37d8",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://3lkw2axfbzch5nwqgiky3fpj6u.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-l4nuyxx4evce7h2hdes7dfl2aa",
    "aws_content_delivery_bucket": "appointment-20200608005519-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d2do3d7e1gunvy.cloudfront.net"
};


export default awsmobile;
